import { Component, OnInit } from '@angular/core';
export class WelcomeComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'welcome',
  template: `
    <div class="container">
        <div class="top-header">
            <h1 class="top-header__name">
                <a href="https://app.penetrace.com">
                  <img src="./../../assets/images/logo.png">
              </a>
            </h1>
            <div class="top-header__slogan">Go with you forever</div>
        </div>
    </div>
    <div class="banner">
         <img class="img-responsive" src="./../../assets/images/banner-slider-1.jpg" />
    </div>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function WelcomeComponent_tsickle_Closure_declarations() {
/** @type {?} */
WelcomeComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WelcomeComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
